import { Ref, computed, defineComponent, ref, toRaw, watch } from 'vue';
import { RouteLocationRaw } from 'vue-router';
import { RouterInstance } from '@/infrastructure/router';

export default defineComponent({
  name: 'dl-breadcrumb',
  setup: () => {
    const breadcrumbLabel = ref('');
    const parentName = ref('');
    const dynamicPath = ref('');
    const toRoute: Ref<RouteLocationRaw> = computed(() =>
      dynamicPath.value !== ''
        ? { name: parentName.value, params: { id: dynamicPath.value } }
        : { name: parentName.value }
    );

    watch(
      () => RouterInstance.data.value,
      () => {
        const breadcrumb = toRaw(RouterInstance.data.value.meta?.breadcrumb);
        dynamicPath.value = breadcrumb?.dynamicPath || '';
        parentName.value = breadcrumb?.parent?.name.toString() || '';
        breadcrumbLabel.value = breadcrumb?.dynamicValue || parentName.value;
      },
      { deep: true, immediate: true }
    );

    return { breadcrumbLabel, parentName, toRoute };
  }
});
